export default __webpack_public_path__ + "static/media/fok.16b5e562.png";